import "../i18n/config";

import "dayjs/locale/pt-br";
import "dayjs/locale/pt";

import "dayjs/locale/es";
import "dayjs/locale/es-mx";
import "dayjs/locale/es-do";
import "dayjs/locale/es-pr";
import "dayjs/locale/es-us";

import "dayjs/locale/he";
import "dayjs/locale/en-il";
import "dayjs/locale/en";

import React from "react";
import { useDependencyInjector } from "@whatslly/commons/di";
import { UserManagementStore } from "./stores/UserManagementStore";
import { observer } from "mobx-react-lite";
import styles from "./UserManagement.module.scss";
import { UsersTable } from "./components/UsersTable";
import type { UserManagementUser } from "./types/UserManagementUser";
import type { LicenseData } from "./types/LicenseData";
import { ModalProviderInline } from "@whatslly/ui-components/modals";
import { UserManagementHeader } from "./components/UserManagementHeader";
import { userManagementModals } from "./stores/userManagementModals";
import { PageHeaderText } from "./components/PageHeaderText/PageHeaderText";

export const UserManagement: React.FC<{ usersTableClassName?: string }> = observer(({ usersTableClassName }) => {
  const store = useDependencyInjector(UserManagementStore);

  return store.users.case({
    pending: () => <UserManagementBody users={[]} loading={true} usersTableClassName={usersTableClassName} />,
    fulfilled: (data) => (
      <UserManagementBody
        users={data.users}
        licenseData={data.licenseData}
        allowInvite={data.allowInvite}
        hideRoles={data.hideRoles}
        hideProfile={data.hideProfile}
        hideTuvisProfile={data.hideTuvisProfile}
        hidePlatform={data.hidePlatform}
        disableActivate={data.disableActivate}
        hideCrmActiveCol={data.hideCrmActiveCol}
        usersTableClassName={usersTableClassName}
      />
    ),
    rejected: (error) => <UserManagementBody users={[]} error={error.message} usersTableClassName={usersTableClassName} />,
  });
});

const UserManagementBody: React.FC<{
  users: UserManagementUser[];
  loading?: boolean;
  error?: string;
  licenseData?: LicenseData;
  allowInvite?: boolean;
  hideRoles?: boolean;
  hideCrmActiveCol?: boolean;
  usersTableClassName?: string;
  hideProfile?: boolean;
  hideTuvisProfile?: boolean;
  hidePlatform?: boolean;
  disableActivate?: boolean;
}> = observer(
  ({
    users,
    error,
    loading,
    licenseData,
    allowInvite,
    hideRoles,
    hideCrmActiveCol,
    usersTableClassName,
    hideProfile,
    hideTuvisProfile,
    hidePlatform,
    disableActivate,
  }) => {
    return (
      <React.Fragment>
        <ModalProviderInline modalService={userManagementModals} />
        <div className={styles.wrapper}>
          <UserManagementHeader
            canCreateSidecar={false}
            availableChannelsForCreation={[]}
            allowInvite={allowInvite}
            users={users}
            loading={loading}
            error={error}
          />
          <PageHeaderText loading={false} licenseData={licenseData} />
          <UsersTable
            hideCrmActiveCol={hideCrmActiveCol}
            hideRoles={hideRoles}
            loading={loading}
            error={error}
            users={users}
            usersTableClassName={usersTableClassName}
            hideProfile={hideProfile}
            hideTuvisProfile={hideTuvisProfile}
            hidePlatform={hidePlatform}
            disableActivate={disableActivate}
          />
        </div>
      </React.Fragment>
    );
  }
);
